import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { FraudModeDataProps } from './props';
import { useEffect, useState } from 'react';
import { ParamEnum, ISelect } from '../../../../../../shared/types/shared';
import { Param } from '../../../../../../shared/types/param';
import { asyncGetLastCodeSuffixParam } from '../../../../../../services/param.service';
import { asyncGetParamByCode } from '../../../../../../services/param.service';

export const useFraudModeData = ({
    data,
    onChangeData,
    onChangeFormik,
}: FraudModeDataProps) => {
    const [newCode, setNewCode] = useState<string>('');
    const [typesPqr, setTypes] = useState<ISelect[]>([]);

    const onSubmit = (data: Param) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_FRAUD_MODE);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('valueSmart', data?.valueSmart || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.id || '');
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeSuffixParam(ParamEnum.PQR_FRAUD_MODE).then(
            (res: any) => {
                setNewCode(res?.items);
            }
        );
    }, [newCode]);

    useEffect(() => {
        const fetchParams = async () => {
            try {
                const paramCodes = [
                    `${ParamEnum.PQR_TYPE}_QEX`,
                    `${ParamEnum.PQR_TYPE}_QOR`,
                ];
                const results = await Promise.all(
                    paramCodes.map((code) => asyncGetParamByCode(code))
                );
                setTypes(
                    results.filter(
                        (item): item is ISelect => item !== undefined
                    )
                );
            } catch (error) {
                console.error('Failed to fetch params:', error);
            }
        };
        fetchParams();
    }, []);

    return {
        formik,
        typesPqr,
    };
};
